<template>
    <div class="video-mark" :style="{ display: show ? 'block' : 'none' }">
        <img
            class="close"
            :src="require('@/assets/img_svg/close.svg')"
            @click="close"
            alt="svg"
        />

        <div class="video-box">
            <video-player
                class="video-player vjs-custom-skin"
                ref="videoPlayer"
                :playsinline="true"
                :options="playerOptions"
            >
            </video-player>
        </div>
    </div>
</template>

<script>
import "video.js/dist/video-js.css";
import { videoPlayer } from "vue-video-player";
export default {
    name: "Video",
    data() {
        return {
            playerOptions: {
                //播放速度
                playbackRates: [0.5, 1.0, 1.5, 2.0],
                //如果true,浏览器准备好时开始回放。
                autoplay: false,
                // 默认情况下将会消除任何音频。
                muted: false,
                // 导致视频一结束就重新开始。
                loop: false,
                // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                preload: "auto",
                language: "zh_CN",
                // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                aspectRatio: "16:9",
                // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                fluid: true,
                sources: [
                    {
                        //类型
                        type: "video/mp4",
                        //url地址
                        src:
                            "https://minio.oceanbluecloud.com/redio/webMov.mp4",
                    },
                ],
                //你的封面地址
                poster: "",
                //允许覆盖Video.js无法播放媒体源时显示的默认信息。
                notSupportedMessage: "此视频暂无法播放，请稍后再试",
                controlBar: {
                    timeDivider: true,
                    durationDisplay: true,
                    remainingTimeDisplay: false,
                    //全屏按钮
                    fullscreenToggle: true,
                },
            },
            show: false,
        };
    },
    methods: {
        start() {
            this.show = true;
            this.$refs.videoPlayer.player.play();
        },
        close() {
            this.$refs.videoPlayer.player.pause();
            this.show = false;
        },
    },
    computed: {
        player() {
            return this.$refs.videoPlayer.player;
        },
    },
    components: {
        videoPlayer,
    },
};
</script>

<style>
.video-mark {
    position: fixed;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.9);
    z-index: 99999999999;
    top: 0;
    left: 0;
}
.video-box {
    width: 1000px;
    position: absolute;
    top: 50%;
    transform: translate(50%, -50%);
    right: 50%;
}
.close {
    width: 20px;
    height: 20px;
    position: absolute;
    right: 30px;
    top: 30px;
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/Pages/Home/Video.vue